$(document).ready(function() {  
  $('.swatch-list-navbar-jtpl .swatch-navbar_varaint-jtpl.variant_list_active').each(function() {
    var $this = $(this);
    var initialHtmlContent = $this.html();
    $this.closest('.swatch-grid-color-wrapper-main').find('.selected-swatch-navbar .swatch-selected-color-navbar').each(function() {
      $(this).find('li').each(function() {
        $(this).html(initialHtmlContent);
      });
    });
  });

});

// $("body").on("click", ".product_wrapper_jtpl .cstm-variant-selector-jtpl .selected-swatch-navbar", function() {
//   var $this = $(this);
//   // alert('hyehey');
//   $(this).find('.swatch-selected-color-navbar').toggleClass('ul-active');
//   $(this).closest('.swatch-grid-color-wrapper-main').find('.swatch-list-navbar-jtpl').toggleClass('div-active');
// });



$("body").on("click", ".swatch-list-navbar-jtpl .swatch-navbar_varaint-jtpl", function() {
var $this_1 = $(this);
var variantImage = $this_1.find("input").attr("data-variant-image");
var variantPrice = $this_1.find("input").attr("data-variant-price");
var variantComparePrice = $this_1.find("input").attr("compare_variant_price");

if (variantComparePrice && variantComparePrice.trim() !== '') {
    $this_1.parents(".product_wrapper_jtpl")
        .find(".variant-price-jtpl")
        .html('<span class="compare-at-price">' + variantComparePrice + '</span> <span class="price">' + variantPrice + '</span>');
} else {
    $this_1.parents(".product_wrapper_jtpl")
        .find(".variant-price-jtpl")
        .html(variantPrice);
}

$this_1
  .parents(".product_wrapper_jtpl")
  .find("img")
  .attr("srcset", variantImage);
  
$this_1.closest('.swatch-list-color-wrapper').find('li').removeClass('variant_list_active');

$this_1.closest('li').addClass('variant_list_active');

  
var variant_title = $this_1.parents(".product_wrapper_jtpl").find(".swatch-grid-color-wrapper-main .swatch-selected-color-navbar .swatch-color-title-jtpl").html();
$this_1
  .parents(".product_wrapper_jtpl")
  .find(".form__label-info")
  .html(variant_title);

var htmlContent = $this_1.html();
$this_1.closest('.swatch-grid-color-wrapper-main').find('.selected-swatch-navbar .swatch-selected-color-navbar li').html(htmlContent);

var variant_swatch = $this_1.closest('.swatch-grid-color-wrapper-main').find('.swatch-list-navbar-jtpl');
variant_swatch.removeClass('div-active');
$this_1.closest('.swatch-grid-color-wrapper-main').find('.swatch-selected-color-navbar').removeClass('ul-active');
});


function add_to_cart(variant_id, default_id, quantity) {
  if (!variant_id && default_id) {
    variant_id = default_id;
  }
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: variant_id,
      quantity: quantity
    },
    dataType: "json",
    success: function (data) {
      updateCart();
      $('body').addClass('mini-cart--open'); 
      $('.header-wrapper').find('.cart-drawer-container').addClass('menu-opening').attr('open', 'open');
      console.log("variant_id" + data);
    },
    error: function (xhr, status, error) {
      console.error("Error Status:", status);
      console.error("Error Thrown:", error);
      console.log("Response:", xhr.responseText);
    },
  });
}
$('body').on('click', '.product_wrapper_jtpl .shop-pro-btn', function() {
  var $this = $(this); 
  var variant_id = $this.closest('.grid__item .product_wrapper_jtpl').find('.swatch-list-style-only.navbar-highlights .swatch-grid-color-wrapper-main .selected-swatch-navbar input').attr("data-variant-jtpl");
 
  var default_id = $this.attr('default-id');
  if (!variant_id){
    variant_id = default_id;
  }
  // console.log("variant_id: " + variant_id);
  var quantity = 1; 
  add_to_cart(variant_id, default_id, quantity);
});
